module.exports = __webpack_public_path__ + "static/media/file-check.edf71afd.svg";